import React from 'react'
import AuthLogo from '../../../../assets/images/auth_logo.png'

/**
 * Left Panel component for authentication screen
 *
 * Displays the Kinstak logo and marketing content with instructions
 * for new users about the benefits of signing up.
 */
const LeftPanel = () => {
  return (
    <div className="left-panel">
      <img className="auth_img" src={AuthLogo} alt="Auth Logo" />
      <ol className="login_instructions">
        <li className="login_list">Sign-up for Free</li>
        <li className="login_list">
          Upload Photos <br></br>
          <p>Unlimited Storage!</p>
        </li>
        <li className="login_list">View Organized Gallery</li>
        <li className="login_list">Create Kin-Categories</li>
      </ol>
    </div>
  )
}

export default LeftPanel
